import type { NotificationRepository } from "../repositories/NotificationRepository";
import type { Unsubscribe } from "@firebase/util";

export class NotificationUseCases {
  constructor(private repository: NotificationRepository) {}

  async getFirebaseToken(
    vapidKey: string,
    serviceWorkerRegistration: ServiceWorkerRegistration
  ): Promise<string> {
    return await this.repository.getFirebaseToken(
      vapidKey,
      serviceWorkerRegistration
    );
  }

  onMessage(callback: (payload: any) => void): Unsubscribe {
    return this.repository.onMessage(callback);
  }
}
